import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export type RequestError = FetchBaseQueryError | SerializedError;

export type Loadable<T> =
  | { status: 'idle' }
  | { status: 'loading' }
  | { status: 'failed'; error: RequestError | undefined }
  | { status: 'loaded'; data: T };

type QueryResult<T> = {
  data?: T;
  isLoading: boolean;
  isError: boolean;
  error?: RequestError;
};

export const IDLE: Loadable<never> = { status: 'idle' };

export const LOADING: Loadable<never> = { status: 'loading' };

export const loaded = <T>(data: T): Loadable<T> => ({ status: 'loaded', data });

export const failed = (error: RequestError | undefined): Loadable<never> => ({ status: 'failed', error });

export function loadableOf<T>({ data, isLoading, isError, error }: QueryResult<T>): Loadable<T> {
  if (isLoading) {
    return LOADING;
  }

  if (isError) {
    return failed(error);
  }

  return data === undefined ? IDLE : loaded(data);
}
